import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import * as React from 'react';
import { cn } from '../utils/cn';

export interface StatCardProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  value: React.ReactNode;
  delta?: number;
  unit?: string;
  icon?: React.ReactNode;
}

/**
 * KPI kártya az admin dashboardhoz — a delta szín-kódolt
 * (zöld = pozitív, piros = negatív, semleges = nulla).
 */
export function StatCard({
  label,
  value,
  delta,
  unit,
  icon,
  className,
  ...props
}: StatCardProps) {
  const positive = typeof delta === 'number' && delta > 0;
  const negative = typeof delta === 'number' && delta < 0;
  return (
    <div className={cn('lectura-card p-6', className)} {...props}>
      <div className="flex items-start justify-between gap-4">
        <p className="text-sm font-medium text-[var(--color-foreground-muted)]">{label}</p>
        {icon ? (
          <span className="flex size-9 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
            {icon}
          </span>
        ) : null}
      </div>
      <p className="mt-3 font-display text-3xl font-bold tracking-tight">
        {value}
        {unit ? <span className="ml-1 text-base font-medium text-[var(--color-foreground-muted)]">{unit}</span> : null}
      </p>
      {typeof delta === 'number' ? (
        <p
          className={cn(
            'mt-2 inline-flex items-center gap-1 text-xs font-semibold',
            positive && 'text-emerald-600',
            negative && 'text-red-600',
            !positive && !negative && 'text-[var(--color-foreground-subtle)]',
          )}
        >
          {positive ? <ArrowUpRight className="size-3.5" /> : null}
          {negative ? <ArrowDownRight className="size-3.5" /> : null}
          {delta > 0 ? '+' : ''}
          {delta}% az előző időszakhoz képest
        </p>
      ) : null}
    </div>
  );
}
